module.exports = __webpack_public_path__ + "static/item--ac--f2@3x.b5f62d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f2@3x.png
// module id = 620
// module chunks = 126511778744290